module.exports = __webpack_public_path__ + "static/media/gayathri.91abad41.webp";